import DescriptionRenderer from './components/DescriptionRenderer';
import ProjectNameRenderer from './components/ProjectNameRenderer';
import TopicNameRenderer from './components/TopicNameRenderer';
import BuildingsRenderer from './components/BuildingsRenderer';
import RecipientsRenderer from './components/RecipientsRenderer';
import TagsRenderer from './components/TagsRenderer';
import StatusRenderer from './components/StatusRenderer';
import DateRenderer from './components/DateRenderer';
import AuthorRenderer from './components/AuthorRenderer';


const columnDefs = [
  {
    field: 'id',
    headerName: 'ID#',
    width: 90,
    hiden: true
  },
  {
    field: 'project.name',
    headerName: 'Project Name',
    width: 220,
    sortable: true,
    cellRenderer: ProjectNameRenderer,
    rowGroup: false, // Can be enabled for grouping
    hide: false,
  },
  {
    field: 'name',
    headerName: 'Topic Name',
    width: 200,
    sortable: true,
    cellRenderer: TopicNameRenderer,
  },
  {
    field: 'description',
    headerName: 'Description',
    width: 350,
    minWidth: 250,
    sortable: false,
    wrapText: true,
    autoHeight: true,
    cellRenderer: DescriptionRenderer,
  },
  {
    field: 'last_response.content',
    headerName: 'Latest Response',
    width: 350,
    minWidth: 250,
    sortable: false,
    wrapText: true,
    autoHeight: true,
    cellRenderer: DescriptionRenderer
  },
  {
    field: 'building_ids',
    headerName: 'Buildings',
    width: 180,
    sortable: false,
    cellRenderer: BuildingsRenderer,
  },
  {
    field: 'recipient_names',
    headerName: 'Recipients (To)',
    width: 180,
    sortable: false,
    cellRenderer: RecipientsRenderer,
  },
  {
    field: 'cc_names',
    headerName: 'CC',
    width: 150,
    sortable: false,
    cellRenderer: RecipientsRenderer,
  },
  {
    field: 'tags',
    headerName: 'Tags',
    width: 150,
    wrapText: true,
    autoHeight: true,
    sortable: false,
    cellRenderer: TagsRenderer,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 100,
    sortable: true,
    cellRenderer: StatusRenderer,
  },
  {
    field: 'closed_date',
    headerName: 'Closed Date',
    width: 130,
    hide: true,
    cellRenderer: DateRenderer,
  },
  {
    field: 'closed_by',
    headerName: 'Closed By',
    width: 130,
    sortable: false,
    hide: true,
  },
  {
    field: 'author.name',
    headerName: 'Created By',
    width: 130,
    autoHeight: true,
    cellRenderer: AuthorRenderer
  },
  {
    field: 'created_date',
    headerName: 'Created Date',
    width: 130
  },
];

export default columnDefs;